import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  contentWrapper: {
    // marginRight: 25,
    // margin: 10,
    // marginLeft: 25,
  },
  head: {
    display: "flex",
    alignItems: "center",
    padding: 10,
    // marginLeft: -10,
    marginBottom: 5,
    backgroundColor: "#efefef",
  },
  title: {
    // flex: 1,
    // margin: "0 10px",
    fontSize: 12,
    // fontWeight: 00,
    color: "#2f2f2f",
  },
  link: {
    fontSize: 12,
    color: "#4fa3d5",
    textDecoration: "none",
  },
  body: {
    color: "#848484",
    padding: "8px 0 18px 10px",
  },
  bodyTitle: {
    fontSize: 12,
    // maxWidth: 10,
    marginTop: 5,
    marginBottom: -10,
    marginLeft: 25,
    marginRight: 20,
  },
  titleBody: {
    // width: "100%",
    // margin: 0,
    marginLeft: 25,
    fontSize: 14,
    fontWeight: 700,
    color: "#2f2f2f",
  },
}));

export default useStyles;
